module.exports = __webpack_public_path__ + "static/media/fly0048.9fb6c682.webp";